import { Component, OnInit, Inject } from '@angular/core';
import { Filter, LotteryFilterParam } from '../../models/filter.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
//import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';


export class FilterStatisticsData {

  public filter:Filter;
  public betId:string;
}


@Component({
  selector: 'kt-filter-statistics-dialog',
  templateUrl: './filter-statistics-dialog.component.html',
  styleUrls: ['./filter-statistics-dialog.component.scss']
})
export class FilterStatisticsDialogComponent implements OnInit {

  params:LotteryFilterParam[] = [];

  constructor(
    public dialogRef: MatDialogRef<FilterStatisticsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterStatisticsData) {

  }

  ngOnInit() {


    
  }

  onNoClick(): void {


    this.dialogRef.close(this.params);
  }

  savedParams(filterParam)
  {
    console.log("FilterStatisticsDialogComponent: savedParams", filterParam);
    let param = this.params.find(x=>x.id == filterParam.id);

    if(param==null)
    {
       console.log("Aqui1");
      this.params.push(filterParam);
    }
    else
    {
           console.log("Aqui2");
      param.maxLimit = filterParam.maxLimit;
      param.minLimit = filterParam.minLimit;
      param.isChecked = filterParam.isChecked;
    }
  }

}
